import React, { useEffect, useState } from "react";

interface SnImageBoxProps {
  defaultValue?: string; // 파일명
  prefix?: string;
  code?: string;
  inputRef?: any;
  onFocus?: (target: string) => void;
}

const SnImageBox = ({
  defaultValue,
  prefix,
  code,
  inputRef,
  onFocus,
}: SnImageBoxProps) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!defaultValue || !code) {
      setImageUrl(null);
      return;
    }

    const encodedFilename = encodeURIComponent(defaultValue);
    const url = `/snotes/file/view/${prefix}/${code}/${encodedFilename}`;
    setImageUrl(url);
  }, [defaultValue, prefix, code, prefix]);

  const handleFocus = () => {
    onFocus && onFocus("next");
  };

  const handleError = () => {
    setImageUrl(null);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        border: "1px solid rgb(196 196 196)",
        backgroundColor: "white",
      }}
      ref={inputRef}
      onFocus={handleFocus}
      tabIndex={-1}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="이미지 미리보기"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
          onError={handleError}
        />
      ) : (
        <span style={{ color: "#999" }}></span>
      )}
    </div>
  );
};

export default React.memo(SnImageBox);
